export const Permission = {
  ViewInvoice: "vt_web_view_invoice_trade",
  ViewTrade: "vt_web_view_individual_trade",
  ViewSummaryDashboard: "vt_web_view_setutrade_summary",
  SelectFarmerInBuyer:
    "vt_core.vt_app_can_select_farmer_in_buyer_field_in_setutrade",
  ViewPayableReceivableReport: "vt_web_can_view_setutrade_payable_reports",
  canSelectAllTradePages: "vt_web_can_select_all_trade_pages",
  canUploadPayableReceivable: "vt_web_can_upload_payable_receivable",
  canApproveCredit: "vt_web_can_approve_credit_limit",
  canAddNewCredit: "vt_web_can_add_new_credit",
  canEditCreditDetails: "vt_web_can_update_credit_details",
  canSendTradeReceiptsViaWhatsApp:
    "vt_web_can_send_trade_receipts_via_whatsapp",
  canViewPackingMaterial: "vt_web_view_packing_material",
  canViewReceivableManagement: "vt_web_view_receivable_management",
  canViewPayableManagement: "vt_web_view_payable_management",
  canViewUploaderManager: "vt_web_view_uploader_manager",
  canViewCreditManagement: "vt_web_view_credit_management",
  canViewExpenseTemplate: "vt_web_view_expense_template",
  canViewVehiclesUnderTrade: "vt_web_can_view_vehicles_under_trade",
  canSendMISReport: "vt_web_can_send_mis_report",
  canViewStockManagement: "vt_web_view_stock_management",
  CanAddAttachmentsAfterTradeVerified:
    "vt_web_can_add_attachments_after_trade_verified",
  CanInactivatePlantSettlement: "vt_web_can_set_plant_transaction_inactive",
  CanViewStorageLocations: "vt_web_view_storage_locations",
  CanViewProductionManagement: "vt_web_can_view_production_management",
  CanEditProductionFinalPatti: "vt_web_can_edit_final_patti",
  CanViewPackagingSelection: "vt_web_can_view_packaging_selection",
  CanVerifyTrades: "vt_web_can_verify_trades",
  CanSettleMultipleTradesAndInvoices:
    "vt_web_can_settle_multiple_trades_and_invoices",
  CanReturnTransactions: "vt_web_can_return_transactions",
  CanCancelInvoice: "vt_web_can_cancel_invoice",
  CanAddMultiCommodityTradesAndReceipts:
    "vt_web_can_add_multiple_commodity_trade_receipt",
  CanDeleteTrades: "vt_web_can_delete_trades",
} as const
